import React, { FC } from 'react';
import i18n from 'i18n';

import { ModalProps } from '../types';
import Dialog from '../../Dialog/index';
import { maxTileNumber } from '../../../../constants';

export const TooManyTilesModal: FC<ModalProps> = ({ app, onCancel, deviceName }) => {
  return (
    <Dialog
      show={true}
      id="TooManyTilesModal"
      title={i18n('component.InstallTileModal.title')({ appName: app.name })}
      message={i18n('component.InstallTileModal.content')({ deviceName: deviceName, tileName: app.name, maxTileNumber })}
      onDismiss={onCancel}
      actions={[
        {
          text: i18n('component.InstallTileModal.cancelText')(),
          onClick: onCancel,
          variant: 'text',
          id: 'uninstall-button-cancel'
        }
      ]}
    />
  );
};

export default TooManyTilesModal;
